import * as React from 'react';
import type {
  UpdateTransportRoutePayload,
  TransportRoute as Response,
} from 'contracts/transport-routes';
import { apiGeneral, handleApiError } from 'services/api';

type Payload = {
  transportRouteId: string | number,
  data: UpdateTransportRoutePayload
}

export const useUpdateTransportRoute = () => {
  const updateTransportRoute = React.useCallback(async (payload: Payload) => {
    try {
      const { data } = await apiGeneral.put<Response>(
        `/general-route/${payload.transportRouteId}`,
        payload.data,
      );
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    updateTransportRoute,
  };
};